import React from "react";
import ReactDOM from "react-dom";

import EventOverview from './components/EventOverview';

const eventOverviewContainer = document.querySelector('.js-event-overview-container');

if (eventOverviewContainer) {
    const { filters, isArchive } = eventOverviewContainer.dataset;

    ReactDOM.render(
        <EventOverview filters={JSON.parse(filters)} isArchive={isArchive} />,
        eventOverviewContainer,
    );
}
